const getViewedPoints = (store) => {
	return (store.Session.viewedPoints || []).filter((i) => !!i);
};

export default getViewedPoints;
